import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-download-software',
  templateUrl: './download-software.component.html',
  styleUrls: ['./download-software.component.scss']
})
export class DownloadSoftwareComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
